var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTymeplusHr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13213_34497)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3,
    width: 62,
    height: 62,
    rx: 31,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5899 30.71C18.6251 25.1206 22.7677 20.5579 28.1063 18.0255C33.4449 15.4931 39.5423 15.1985 45.057 17.2066C49.8034 18.9349 54.0381 23.0013 56.549 26.9885C54.1376 21.8273 49.3363 16.7385 43.5966 14.6485C38.9127 12.9435 33.7857 12.8738 29.0301 14.4506C24.2745 16.0274 20.1631 19.1601 17.3492 23.3511C14.5353 27.5422 13.1802 32.551 13.4994 37.5818C13.8185 42.6127 15.7935 47.377 19.1105 51.1177C17.1013 48.1829 15.8236 44.7973 15.3849 41.2458C14.9463 37.6943 15.3595 34.081 16.5899 30.71Z",
    fill: "#EE2738"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0194 24.1133L34.4263 38.04L33.4539 36.99L48.0194 24.1133Z",
    fill: "#2D53DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.354 30.416L34.9439 36.5109L33.9825 37.5712L27.354 30.416Z",
    fill: "#2D53DA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13213_34497",
    x: 0,
    y: 0,
    width: 70,
    height: 70,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13213_34497"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13213_34497",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTymeplusHr);
export default __webpack_public_path__ + "static/media/TymeplusHR.15429e58b99ee72addfba15ed25f63c9.svg";
export { ForwardRef as ReactComponent };